import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

const routerHistory = createWebHistory()


const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/productService',
        name: 'productService',
        component: () => import('../views/ProductServiceView.vue')        
    },
    {
        path: '/solution',
        name: 'solution',
        component: () => import('../views/SolutionView.vue')
    },
    {
        path: '/companyProfile',
        name: 'companyProfile',
        component: () => import('../views/CompanyProfileView.vue')
    },
    {
        path: '/latestConsultation',
        name: 'latestConsultation',
        component: () => import('../views/LatestConsultationView.vue')
    },
    {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('../views/ContactUsView.vue')
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('../views/TestView.vue')
    },
    {
        path: '/yangshi',
        name: 'yangshi',
        component: () => import('../views/yangshi.vue')
    },
    {
        path: '/NewHeader',
        name: 'NewHeader',
        component: () => import('../views/NewHeader.vue')
    },
    /**
     * 医美连锁路由
     */
    {
        path: '/solution/chain/beauty',
        name: 'solution-chanin-beauty',
        component: () => import('../views/solution/chain/beauty.vue')
    },
    /**
     * 餐饮连锁路由
     */
    {
        path: '/solution/chain/food',
        name: 'solution-chain-food',
        component: () => import('../views/solution/chain/food.vue')
    },
    /**
     * 住宿连锁路由
     */
    {
        path: '/solution/chain/hotel',
        name: 'solution-chain-hotel',
        component: () => import('../views/solution/chain/hotel.vue')
    },
    /**
     * 本地生活路由
     */
    {
        path: '/solution/platform/local',
        name: 'solution-platform-local',
        component: () => import('../views/solution/platform/local.vue')
    },
    /**
     * 平台电商路由
     */
    {
        path: '/solution/platform/ecommerce',
        name: 'solution-platform-ecommerce',
        component: () => import('../views/solution/platform/ecommerce.vue')
    },
    /**
     * 租住服务路由
     */
    {
        path: '/solution/platform/rent',
        name: 'solution-platform-rent',
        component: () => import('../views/solution/platform/rent.vue')
    },
    /**
     * 出行服务路由
     */
    {
        path: '/solution/platform/travel',
        name: 'solution-platform-travel',
        component: () => import('../views/solution/platform/travel.vue')
    },
    /**
     * 小微商户路由
     */
    {
        path: '/solution/small/merchant',
        name: 'solution-small-merchant',
        component: () => import('../views/solution/small/merchant.vue')
    },
    /**
     * 休娱场所路由
     */
    {
        path: '/solution/small/entertainment',
        name: 'solution-small-entertainment',
        component: () => import('../views/solution/small/entertainment.vue')
    },
    /**
     * 数字权益路由
     */
    {
        path: '/solution/digital/rights',
        name: 'solution-digital-rights',
        component: () => import('../views/solution/digital/rights.vue')
    },
    /**
     * 链上支付路由
     */
    {
        path: '/solution/digital/payment',
        name: 'solution-digital-payment',
        component: () => import('../views/solution/digital/payment.vue')
    },
    /**
     * 直播电商路由
     */
    {
        path: '/solution/digital/livestream',
        name: 'solution-digital-livestream',
        component: () => import('../views/solution/digital/livestream.vue')
    },
    /**
     * 基础产品路由
     */
    {
        path: '/products/basic',
        name: 'products-basic',
        component: () => import('../views/products/basic.vue')
    },
    /**
     * FacPay设备路由
     */
    {
        path: '/products/device',
        name: 'products-device',
        component: () => import('../views/products/device.vue')
    },
    /**
     * 标准解决方案路由
     */
    {
        path: '/products/standard',
        name: 'products-standard',
        component: () => import('../views/products/standard.vue')
    },
    /**
     * 场景解决方案路由
     */
    {
        path: '/products/scenario',
        name: 'products-scenario',
        component: () => import('../views/products/scenario.vue')
    },
    /**
     * 跨境电商路由
     */
    {
        path: '/solution/global/ecommerce',
        name: 'global-ecommerce',
        component: () => import('../views/solution/global/ecommerce.vue')
    },
    /**
     * 外贸收款路由
     */
    {
        path: '/solution/global/export',
        name: 'global-export',
        component: () => import('../views/solution/global/export.vue')
    },
    /**
     * 公司介绍路由
     */
    {
        path: '/about/intro',
        name: 'about-intro',
        component: () => import('../views/about/intro.vue')
    },
    /**
     * 联系我们路由
     */
    {
        path: '/about/contact',
        name: 'about-contact',
        component: () => import('../views/about/contact.vue')
    },
    /**
     * 合作支付公司路由
     */
    {
        path: '/partners/payment',
        name: 'partners-payment',
        component: () => import('../views/partners/payment.vue')
    },
    /**
     * 合作银行路由
     */
    {
        path: '/partners/bank',
        name: 'partners-bank',
        component: () => import('../views/partners/bank.vue')
    },
    /**
     * 支付公司合作银行
     */
    {
        path: '/partners/bankPayment',
        name: 'partners-bank-Payment',
        component: () => import('../views/partners/bankPayment.vue')
    },
    /**
     * 关于我们联系我们
     */
    {
        path: '/about/introContact',
        name: 'about-intro-Contact',
        component: () => import('../views/about/introContact.vue')
    }

]

const router = createRouter({
    mode: 'history',
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPositiion) {
        return { x: 0, y: 0}
    }
})

export default router